import React from "react";
import OrderStatus from "pages/OrderStatus/OrderStatus";

function OrderComplete() {
  return <OrderStatus type="COMPLETE" />;
}

export default OrderComplete;
